import styled from 'styled-components';

export const ActiveCustomerDetailsStyles = styled.section`
  #back-button {
    margin: 10px;
    display: flex;
    -webkit-box-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    align-items: center;
    height: 40px;
    width: 40px;
    color: var(--greenia-color);
    font-size: 20px;
    border: 1px solid var(--greenia-color);
    border-radius: 100%;
    cursor: pointer;
  }
`;

export const CustomerDetailsHeader = styled.div`
  background: linear-gradient(135deg, #00a651 0%, #008a44 100%);
  color: white;
  padding: 2rem;
  border-radius: 12px;
  margin-bottom: 2rem;
  box-shadow: 0 4px 12px rgba(0, 166, 81, 0.15);

  h2{
    font-size: 1.75rem;
  }

  @media (min-width: 999px)and (max-width: 1300px) {
  padding: 1rem 1rem 1rem 0.5rem;

  h2{
    font-size: 1.2rem;
  }
    
  }
`;

export const BackBtnCustom = styled.div`
  background: rgba(255, 255, 255, 0.2);
  border: 2px solid rgba(255, 255, 255, 0.3);
  color: white;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-right: 1rem;

  &:hover {
    background: rgba(255, 255, 255, 0.3);
    transform: translateX(-3px);
    transition: all 0.3s ease;
  }
`;

export const ActionCard = styled.div`
  background: rgba(255, 255, 255, 0.15);
  border-radius: 10px;
  padding: 1rem;
  backdrop-filter: blur(10px);

  p {
    color: rgba(255, 255, 255, 0.95);
    font-size: 0.85rem;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 0.5rem;
    transition: all 0.3s ease;
  }
`;

export const InfoCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  height: 100%;
  border: 1px solid #f0f0f0;
  transition: all 0.3s ease;

  .custom-label-size {
    font-size: 0.9rem;
  }

  &:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
    transform: translateY(-2px);
    transition: all 0.3s ease;
  }

  h4 {
    color: #00a651;
    font-weight: 600;
  }

  .form-label {
    color: #555;
  }

  .form-control {
    border-radius: 8px;
    border: 1px solid #e0e0e0;
    padding: 0.6rem 0.85rem;
    font-size: 0.95rem;
    transition: all 0.3s ease;

    &:focus {
      border-color: #00a651;
      box-shadow: 0 0 0 3px rgba(0, 166, 81, 0.1);
      outline: none;
    }
  }

  select.form-control {
    cursor: pointer;
  }

  @media (min-width: 999px) and (max-width: 1250px) {
    h4{
      font-size: 1.3rem;
    }
  }
`;

export const InfoList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;

  li {
    padding: 0.75rem 0;
    border-bottom: 1px solid #f5f5f5;
    display: flex;
    align-items: center;

    &:last-child {
      border-bottom: none;
    }

    strong {
      color: #333;
      min-width: 140px;
      font-weight: 500;
    }

    span {
      color: #666;
    }
  }
`;

export const SectionCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  margin-bottom: 2rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border: 1px solid #f0f0f0;
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1.25rem;
  padding-bottom: 0.75rem;
  border-bottom: 2px solid #f0f0f0;

  h5 {
    color: #333;
    font-weight: 600;
    margin: 0;
    font-size: 1.25rem;
  }
`;

export const SectionBadge = styled.span`
  background: #00a651;
  color: white;
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-size: 0.75rem;
  margin-left: auto;
  font-weight: 500;
`;

export const CustomTable = styled.table`
  margin: 0;
  border: none;

  thead th {
    background: #f8f9fa;
    color: #333;
    font-weight: 600;
    border: none;
    padding: 1rem;
    text-transform: uppercase;
    font-size: 0.75rem;
    letter-spacing: 0.5px;
  }

  tbody td {
    padding: 1rem;
    vertical-align: middle;
    border-top: 1px solid #f0f0f0;
  }

  tbody tr {
    transition: all 0.3s ease;

    &:hover {
      background: #f8f9fa !important;
      transition: all 0.3s ease;

      td {
        color: #333 !important;

        strong {
          color: #333 !important;
        }

        span {
          color: #666 !important;
        }
      }
    }
  }
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 3rem 1rem;
  color: #999;
`;

export const EmptyStateIcon = styled.div`
  font-size: 3rem;
  margin-bottom: 1rem;
  opacity: 0.3;
`;

export const BtnWhiteOutline = styled.button`
  background: white;
  border: 2px solid white;
  color: #00a651;
  font-weight: 500;
  padding: 0.5rem 1.25rem;
  border-radius: 8px;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.9);
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  }

  @media (min-width: 999px) and (max-width: 1250px) {
  padding: 0.5rem 1rem;
    
  }
`;

export const BadgeCustom = styled.span`
  padding: 0.4rem 0.6rem;
  border-radius: 6px;
  font-weight: 500;
  font-size: 0.75rem;
`;

export const ContactBtn = styled.button`
  background: linear-gradient(135deg, #00a651 0%, #008a44 100%);
  color: white;
  border: none;
  padding: 0.6rem 1.5rem;
  border-radius: 8px;
  font-weight: 500;
  transition: all 0.3s ease;
  width: 100%;
  margin-top: 0.5rem;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 166, 81, 0.3);
  }
`;

export const ReadMailBtn = styled.div`
  a {
    padding: 8px 15px;
    font-weight: normal;
    background-color: #00a651;
    color: #ffffff;
    border: 1px solid #00a651;
    transition: all ease-in-out 300ms;
    cursor: pointer;
    border-radius: 5px;
    font-size: 12px;
    text-transform: uppercase;

    &:hover {
      background-color: transparent;
      color: #00a651;
      font-weight: normal;
    }
  }
`;

export const TableRowStyle = styled.tr`
  transition: all 300ms ease-in-out;

  &:hover {
    background-color: #00a651;
    color: #ffffff;
  }

  .document-actions {
    display: flex;
    gap: 0.5rem;
    padding-top: 0.75rem;

    .btn-download {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 0.4rem;
      padding: 0.4rem 0.6rem;
      background: linear-gradient(135deg, #00a651 0%, #00873f 100%);
      border: none;
      border-radius: 8px;
      color: #ffffff;
      font-size: 0.8rem;
      font-weight: 600;
      cursor: pointer;
      transition: all 0.2s ease;

      &:hover {
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(0, 166, 81, 0.3);
      }
    }

    .btn-upload {
        flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 0.4rem;
      padding: 0.4rem 0.6rem;
      border: none;
      border-radius: 8px;
      color: #ffffff;
      font-size: 0.8rem;
      font-weight: 600;
      cursor: pointer;
      transition: all 0.2s ease;
      background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);

      &:hover {
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(245, 158, 11, 0.3);
      }
    }
  }
`;
